export default {
  related: 'Articoli correlati',
}
